import { ContractInfoMainnet } from "../contracts/DieAfter100HrsNft";

export const BlogURL = "https://nawoo.hateblo.jp/entry/die-after-100hrs";
export const OpenSeaURL = "https://opensea.io/collection/die-after-100hrs";
export const PolygonscanURL = "https://polygonscan.com/address/" + ContractInfoMainnet.address + "#code";
export const TwitterURL = "https://twitter.com/NowAndNawoo";
